import { ACCESS_TOKEN, DEV_ACCESS_TOKEN, PROD_MODE } from '@app/constants';
import type { NUtils } from '@app/types/Utils';
import { defineDeployingMode } from '@app/utils/defineDeployingMode';

export const defineAccessTokenName: NUtils.DefineAccessTokenName = (
  clientHost
) => {
  const mode = defineDeployingMode(clientHost);
  const isProd = mode === PROD_MODE;

  return isProd ? ACCESS_TOKEN : DEV_ACCESS_TOKEN;
};
